import { RoutesLocation } from 'redux-little-router';

import { ErrorLoadData } from '../api/DNAApolloClient/DNAApolloClient';
import { ItemNameEditorsState } from '../canvas/CanvasEditableLabel/typings';
import { CanvasState } from '../canvas/common/state';
import { SharedData } from '../canvas/common/typings';
import { Html5State } from '../canvas/Html5App/state';
import { SelectorStatus } from '../components/CampaignAndGroupSelector/CampaignAndGroupSelector';
import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import { PhraseAdjustmentItem } from '../components/PhraseAdjustment/PhraseAdjustment';
import { VideoCreatorApiResponse } from '../video-creator/api/typings';
import { VideoCreatorEditState } from '../video-creator/VideoCreatorEditPage/typings';
import { TemplateListItem } from '../video-creator/VideoCreatorHelper/typings';

import {
    AudienceTargetingsEditorState,
    CryptaAudioGenresEditorState,
    CryptaBehavioralEditorState,
    CryptaGroupFamilyEditorState,
    CryptaSocialDemoEditorState,
    InterestsTargetingEditorState
} from './audienceTargetings';
import { BannerCreativePreviewPopupState } from './bannerCreativePreviewPopupState';
import { BannerPricesPopupState } from './bannerPricesPopupState';
import { ImageEditorId, MetroStationInfo } from './banners';
import { CanvasPageType } from './banners';
import {
    BannersEditMassActionsState,
    BannersSiteLinksEditorState,
    CalloutsEditorState,
    EditBannersState,
    EditedBannerImage,
    EditedBannerImageGallery,
    EditorBannerPriceState
} from './bannersEditState';
import { CampaignPlaceEditorState } from './campaignPlaceEditor';
import { EditCampaignsState } from './campaignsEdit';
import { CampaignServiceEditorState } from './campaignServiceEditor';
import { AddChatListEditorState, ChatListEditorState } from './chatList';
import { ColumnsSettingsEditorState } from './columnsSettingsEditor';
import {
    AccessRights,
    AuthorizationData,
    ClientInfo,
    ClientProperties,
    ColumnsSettingsViewDict,
    DictionaryItem,
    DropdownChooserItem,
    MeasurerSystem,
    OperatorData,
    PageStatus,
    Region,
    Tld,
    UserAccountsInfo,
    ValidationResultItem,
    WalletData
} from './common';
import { CommonPriceEditorState } from './commonPriceEditorState';
import { ConstData } from './constants';
import { CreativeState } from './creative';
import { CryptaSegment } from './cryptaSegments';
import { DatesIntervalEditorsState } from './datesInterval';
import { DealDetail, DealsCacheKeysDict, DealsData, DealsSourceParams, DealsUpdateObject } from './deals';
import { DevInfo } from './dev';
import {
    IndoorMapCommonData,
    IndoorMapEditorState,
    OutdoorMapCommonData,
    OutdoorMapEditorState,
    PlatformsPreviewEditorState
} from './displayMap';
import { HelpLink, Tooltips } from './doc-center';
import {
    AdditionalFiltersDict,
    Banner,
    CampaignsCalcTypeFilter,
    CampaignType,
    CopyTooltipStatus,
    FilterGridViewDict
} from './domain';
import { EditPageItemNameEditorsState } from './editPageItemNameEditor';
import { ExperimentsEditorState } from './experimentsEditor';
import { FeedFiltersState } from './feedFilters';
import {
    Freelancer,
    FreelancerCardEditState,
    FreelancerCardOperator,
    FreelancerCustomer,
    FreelancerCustomersState,
    FreelancerFeedbackCommonData,
    FreelancerFeedbackFormModes,
    FreelancerPageStates,
    FreelancersList,
    StringInputField
} from './freelancers';
import { Goal, GoalDecl } from './goals';
import {
    CurrencyCode,
    GdiRecommendationType,
    GdMenuItem,
    GdStringDictNameInput,
    OperatorFeaturesFragment
} from './graphql-grid';
import { GridActionFeatures, GridData, GridEditCells, GridEditedEntity, GridSelectionInfo } from './grid';
import {
    DuplicateGroupsModalViewState,
    DuplicateItem,
    DuplicateRadioControlType,
    DuplicateValidationResults,
    GroupId
} from './groups';
import { EditGroupsState, GroupsEditMassActionsState, MassActionId } from './groupsEditState';
import { HeaderInfoBlockData } from './header';
import { ImageSmartCenterEditorState } from './imageSmartCenterEditor';
import { ImportExportWizardState } from './importExportWizard';
import { ImportWizardState } from './importWizard';
import { ImportWizardInfoState } from './importWizardInfo';
import { PricesWizardData } from './inspector';
import { EditInternalBannersState } from './internalBannersEditState';
import { InternalProductPlacesState } from './internalProductPlace';
import { ItemsListTextareaEditorsState } from './itemsListTextareaEditorState';
import { KeywordsEditorsState } from './keywordsEditorData';
import { LogParams } from './log';
import { MarketersState, MarketerState } from './marketers';
import { MessagesState } from './messagesState';
import { MetrikaCounterEditorState } from './metrikaCounterEditor';
import { MetrikaKeyGoalsEditorState } from './metrikaKeyGoals';
import { MinusPhraseLibraryGrid, MinusPhraseLibraryModalType, MinusPhrasesLibraryItem } from './minusPhraseLibrary';
import { AddLibraryListEditor, MinusKeywordsEditorData } from './minusPhrases';
import { AppInfo, AppsData, AppSettings, MobileAppPageState } from './mobile-apps';
import { NotificationEditorsState } from './notificationEditor';
import { OrganizationsDataState, OrganizationsEditorsState } from './organizations';
import {
    PhrasesSelectorsPersistentState,
    PhrasesSelectorState,
    PhrasesSelectorWizardId,
    PhrasesSelectorWizardState
} from './phrases';
import { PITagsEditorState } from './piTags';
import { PredictorData } from './predictor';
import {
    PricePackageEditorState,
    PricePackagesClientsModalState,
    PricePackagesEditState,
    PricePackagesState
} from './pricePackages';
import { ProductsState } from './products';
import { RateCorrectionEditorState } from './ratesCorrections';
import {
    RecommendationsGridSummaryRecommendation,
    RecommendationsModalState,
    SummaryRecommendation
} from './recommendations';
import { RegionsState } from './regions';
import { RegionsEditorState } from './regionsEditor';
import { RegionsSearchEditorsState } from './regionsSearchEditor';
import { RegionsTransformEditorsState } from './regionsTransformEditor';
import { CampaignsRelevantPhrasesEditorState } from './relevantPhrases';
import { ReportRequestSetData } from './reports';
import { ReportClient } from './reportsClient';
import { ReportDomain } from './reportsDomain';
import { RetargetingAudienceEditorState, RetargetingConditionEditorState, RetargetingEditorState } from './retargeting';
import { SearchAndReplaceInspectorState } from './searchAndReplace';
import { ShowsFrequencyEditorState } from './showsFrequency';
import { CampaignAndGroupSelectorEntityToSelectType, SidebarState } from './sidebar';
import { StrategyEditorState } from './strategyEditor';
import { TagCloudTargetingsState } from './tagCloudTargeting';
import { TargetTagsEditorState } from './targetTagsEditor';
import { TimeTargetingEditorsState, TimeZoneGroup } from './timeTargetingEditor';
import { TrackingParametersEditorsState } from './trackingParametersEditor';
import { TurbolandingsState } from './turbolandings';
import { VideoState } from './video';
import { VisitingCardEditorsState } from './VisitingCardEditor';
import { WelcomeBannerParams, WelcomePageState, WelcomeScreenData } from './welcome';

export interface GridState {
    availableCampaignTypes?: CampaignType[];
    gridData: GridData;
    textSuggestItems: Array<string>;
    isSuggestItemsRequested: boolean;
    hasObjectsOverLimit: boolean;
    selectionInfo: GridSelectionInfo;
    clientInfo: ClientInfo;
    isActionInProgress: boolean;
    editedEntity?: GridEditedEntity;
    columnsSettings: ColumnsSettingsViewDict;
    scrollPosition?: number;
    isHeaderVisible: boolean;
    isHorizontalScrollVisible: boolean;
    editCellsData: GridEditCells;
    tooltips: Tooltips;
    inspector: {
        pricesWizardOpened: boolean;
    };
    pricesWizardData: PricesWizardData;
    isGridScrolling: boolean;
    searchAndReplaceInspectorState: SearchAndReplaceInspectorState;
    campaignAndGroupSelector: CampaignAndGroupSelectorState;
    additionalFilterDict: AdditionalFiltersDict;
    campaignsCalcTypeFilter?: CampaignsCalcTypeFilter;
    isGridTotalBoxVisible: boolean;
    isOnlyFavoriteCampaignsVisible: boolean;
    isCompactViewEnabled: boolean;
    filterDict?: FilterGridViewDict;
    bannersPricesPopup: BannerPricesPopupState;
    bannerAimingPopup?: BannerAimingPopupData;
    gridReqId: string;
    phraseAdjustment: {
        visible: boolean;
        showsForecast?: number;
        hasMoreItems: boolean;
        items?: PhraseAdjustmentItem[];
    };
    duplicateGroupsData: DuplicateGroupsGridData;
    minusPhrasesSelectorData: MinusPhraseSelectorGridData;
    isFilterParamsChanged: boolean;
    gridActionFeatures?: GridActionFeatures;
    goalsSettings?: GoalDecl[];
    retargetingRulesInfo: {
        copyTooltipStatus: CopyTooltipStatus;
    };
    feedFilters: {
        isRateModalOpen: boolean;
        isPriorityModalOpen: boolean;
    };
    brandLiftRejectReason: Record<string, string[]>;
}

export interface DuplicateGroupsGridData {
    selectedRadioButtonType: DuplicateRadioControlType;
    items: DuplicateItem[];
    isModalOpen: boolean;
    isCopyLoading?: boolean;
    modalViewState: DuplicateGroupsModalViewState;
    selectedCampaign?: SelectorItems;
    campaignsSelector: {
        draftCampaignSelected?: SelectorItems;
        campaignItems?: Array<SelectorItems>;
        error: boolean;
        textInput?: string;
        isLoading: boolean;
    };
    validationResults: DuplicateValidationResults;
}

export interface MinusPhraseSelectorGridData {
    groupsIds: string[];
    selectedMinusPhrasesIds: string[];
    isMinusPhraseSelectorModalOpened: boolean;
    items?: MinusPhraseSelectorItemsData[];
    apiError?: boolean;
    isLoading?: boolean;
}

export interface MinusPhraseSelectorItemsData {
    preview: string;
    id: string;
    name: string;
}

export interface GoalsDataState {
    goals?: Record<string, Goal>;
}

export interface PhraseAdjustmentDataChange {
    hasMoreItems?: boolean;
    showsForecast?: number;
    items?: PhraseAdjustmentItem[];
}

export interface BannerAimingPopupData {
    id: string;
    bannerId: string;
    campaignId: string;
    pending: boolean;
}

export interface CampaignAndGroupSelectorState {
    groupSelected?: SelectorItems;
    groupItems?: Array<SelectorItems>;
    campaignSelected?: SelectorItems;
    campaignItems?: Array<SelectorItems>;
    selectorStatus: SelectorStatus;
    isCampaignAndGroupSelectorOpen: boolean;
    entityToSelectType?: CampaignAndGroupSelectorEntityToSelectType;
}

export interface BannersPreviewDataDict {
    [key: string]: {
        banners?: Banner[];
        error?: string;
    };
}

export interface LogState {
    gridData: GridData;
    logParams?: LogParams;
    rowExpanded: Map<number, boolean>;
    rowsCanExpand: Map<number, boolean>;
    nextPageToken?: string | null;
    columnsSettings: ColumnsSettingsViewDict;
    login: string;
    isClient: boolean;
    allExpanded: boolean;
    isHorizontalScrollVisible: boolean;
    isHeaderVisible: boolean;
    changedValueWidth: number;
    maxHeightCleared: boolean;
}

export interface ReportsClientState {
    reportsClient?: Array<ReportClient>;
    errorLoadData?: ErrorLoadData;
    columnsSettings: ColumnsSettingsViewDict;
    loading: boolean;
    periodValue?: ReportRequestSetData;
    login?: string;
}

export interface ReportsDomainState {
    reportsDomain?: Array<ReportDomain>;
    errorLoadData?: ErrorLoadData;
    columnsSettings: ColumnsSettingsViewDict;
    loading: boolean;
    periodValue?: ReportRequestSetData;
    login?: string;
}

export interface WelcomeState {
    pageState: WelcomePageState;
    isLoading: boolean;
    baseSettings: WelcomeScreenData;
    welcomeBanner?: WelcomeBannerParams;
}

export interface MobileAppsListState {
    gridData: AppsData;
}

export interface MobileAppsState {
    pageState: MobileAppPageState;
    appInfo: AppInfo;
    appSettings: AppSettings;
    errors?: ValidationResultItem[];
    id?: string;
}

export type MinusKeywordsIds = GroupId | MassActionId;

export interface MinusPhraseLibraryEditorState {
    data: Record<MinusKeywordsIds, MinusPhraseLibraryEditorData>;
    libraryItems?: MinusPhrasesLibraryItem[];
    libraryItemsApiError?: boolean;
    libraryItemsIsLoading?: boolean;
    libraryItemsIsUpdating?: boolean;
    isLibraryListsFetched?: boolean;
}

export interface MinusPhraseLibraryEditorData {
    minusKeywordsEditor: MinusKeywordsEditorData;
    addLibraryListEditor?: AddLibraryListEditor;
}

export interface MinusPhraseLibraryState {
    gridData: MinusPhraseLibraryGrid;
    columnsSettings: ColumnsSettingsViewDict;
    isHeaderVisible: boolean;
    modalStatus: MinusPhraseModalStatus;
    minusPhraseList: MinusPhraseList;
    errors?: ValidationResultItem[];
}

export interface MinusPhraseModalStatus {
    modalType?: MinusPhraseLibraryModalType;
    isVisible: boolean;
    isLoading?: boolean;
}

export interface MinusPhraseList {
    title: string;
    minusPhrases: string;
    id?: string;
}

export interface ManagerInfo {
    name: string;
    login: string;
    email: string;
    phone: string | null;
}

export interface AgencyInfo {
    clientId?: GraphQlLong;
    userId?: GraphQlLong;
    name?: string;
    login?: string;
    email?: string;
    phone?: string;
    representativeName?: string;
}

export type StringDicts = Partial<Record<GdStringDictNameInput, DictionaryItem[]>>;

export interface UserSettingsState {
    reqId?: string;
    pageStatus: PageStatus;
    measurerAccounts: MeasurerSystem[];
}

export interface CommonState {
    constants?: ConstData;
    sidebar: SidebarState;
    availableCampaignTypes: CampaignType[];
    measurerAccounts: MeasurerSystem[];
    accessRights: AccessRights;
    wallet: WalletData;
    isRecommendationTooltipHidden?: boolean;
    authorizationData?: AuthorizationData;
    clientFreelancerData?: ClientFreelancerData;
    isClientFreelancerDataLoading: boolean;
    login: string;
    clientMobileAppsData?: ClientMobileAppsData;
    regions?: Regions;
    metroStations?: Record<number, Array<MetroStationInfo>>;
    stringDicts?: StringDicts;
    timeZoneGroups?: TimeZoneGroup[];
    tld: Tld;
    cspNonce: string;
    operator: OperatorData;
    publicDomain: boolean;
    totalCount?: number;
    client: ClientProperties;
    features: ClientFeatures;
    screenError: {
        message?: string;
        showLinkSwitchOnOldInterface?: boolean;
        isVisible: boolean;
        title?: string;
    };
    operatorFeatures: OperatorFeaturesFragment;
    dataFetched: boolean;
    fromOldInterface: boolean;
    cryptaSegments: CryptaSegment[];
    outdoorMapData?: OutdoorMapCommonData;
    indoorMapData?: IndoorMapCommonData;
}

export interface ClientFeatures {
    isGridEnabled?: boolean;
    isFeatureGoalsStatInGridEnabled?: boolean;
    isGoalsStatEnabled?: boolean;
    isCpmCampaignsEnabled?: boolean;
    isBidCorrectionSearchEnabled?: boolean;
    isTextCampaign8SitelinksEnabled?: boolean;
    isCpmVideoSeveralPixelsEnabled?: boolean;
    isEmptyRetCondInCpmGroupEnabled?: boolean;
    isCpcDeviceModifiersAllowed?: boolean;
    isCpmIndoorSegmentsEnabled?: boolean;
    isTextBannerInterestsRetCondEnabled?: boolean;
    isInAppEventsInRmpEnabled?: boolean;
    isContentPromotionCampaignInDnaSupported?: boolean;
    isContentPromotionVideoInGridSupported?: boolean;
    isContentPromotionCollectionInGridSupported?: boolean;
    isNewKeywordsEditorForDnaEnabled?: boolean;
    isRoiMeaningfulGoalsOptimizationEnabled?: boolean;
    isAloneTrafaretOptionEnabled?: boolean;
    hasAbSegments?: boolean;
    isMassEditRegionsEnabled?: boolean;
    isOverlayCreativesEnabled?: boolean;
    isVideoConstructorEnabled?: boolean;
    isDefaultAutobudgetAvgCpaEnabled?: boolean;
    isCpmBannerCampaignAddAllowed?: boolean;
    isCpmBannerCampaignUpdateAllowed?: boolean;
    isHonestAddTextAdGroupAllowed?: boolean;
    relevanceMatchForNewGroupsEnabled?: boolean;

    isAdmetricaMeasurerCpmDealsAllowed?: boolean;
    isAdmetricaMeasurerCpmAudioAllowed?: boolean;
    isAdmetricaMeasurerCpmVideoAllowed?: boolean;
    isAdmetricaMeasurerCpmBannerAllowed?: boolean;
    isAdmetricaMeasurerCpmGeoproductAllowed?: boolean;
    isAdmetricaMeasurerCpmYndxFrontpageAllowed?: boolean;

    isAdlooxMeasurerCpmAudioAllowed?: boolean;
    isAdlooxMeasurerCpmBannerAllowed?: boolean;
    isAdlooxMeasurerCpmDealsAllowed?: boolean;
    isAdlooxMeasurerCpmGeoproductAllowed?: boolean;
    isAdlooxMeasurerCpmVideoAllowed?: boolean;
    isAdlooxMeasurerCpmYndxFrontpageAllowed?: boolean;

    isAdriverMeasurerCpmAudioAllowed?: boolean;
    isAdriverMeasurerCpmBannerAllowed?: boolean;
    isAdriverMeasurerCpmDealsAllowed?: boolean;
    isAdriverMeasurerCpmGeoproductAllowed?: boolean;
    isAdriverMeasurerCpmVideoAllowed?: boolean;
    isAdriverMeasurerCpmYndxFrontpageAllowed?: boolean;

    isCpaPayForConversionsStrategyAllowed?: boolean;

    isDvMeasurerCpmBannerAllowed?: boolean;
    isDvMeasurerCpmAudioAllowed?: boolean;
    isDvMeasurerCpmDealsAllowed?: boolean;
    isDvMeasurerCpmGeoproductAllowed?: boolean;
    isDvMeasurerCpmVideoAllowed?: boolean;
    isDvMeasurerCpmYndxFrontpageAllowed?: boolean;

    isIntegralAdScienceMeasurerCpmBannerAllowed?: boolean;
    isIntegralAdScienceMeasurerCpmAudioAllowed?: boolean;
    isIntegralAdScienceMeasurerCpmDealsAllowed?: boolean;
    isIntegralAdScienceMeasurerCpmGeoproductAllowed?: boolean;
    isIntegralAdScienceMeasurerCpmVideoAllowed?: boolean;
    isIntegralAdScienceMeasurerCpmYndxFrontpageAllowed?: boolean;

    isLandingsWizardAllowed?: boolean;

    isMediascopeMeasurerCpmBannerAllowed?: boolean;
    isMediascopeMeasurerCpmAudioAllowed?: boolean;
    isMediascopeMeasurerCpmDealsAllowed?: boolean;
    isMediascopeMeasurerCpmGeoproductAllowed?: boolean;
    isMediascopeMeasurerCpmVideoAllowed?: boolean;
    isMediascopeMeasurerCpmYndxFrontpageAllowed?: boolean;

    isMediascopeMeasurerEnabled?: boolean;

    isMoatMeasurerCpmBannerAllowed?: boolean;
    isMoatMeasurerCpmAudioAllowed?: boolean;
    isMoatMeasurerCpmDealsAllowed?: boolean;
    isMoatMeasurerCpmGeoproductAllowed?: boolean;
    isMoatMeasurerCpmVideoAllowed?: boolean;
    isMoatMeasurerCpmYndxFrontpageAllowed?: boolean;

    isSizmekMeasurerCpmBannerAllowed?: boolean;
    isSizmekMeasurerCpmAudioAllowed?: boolean;
    isSizmekMeasurerCpmDealsAllowed?: boolean;
    isSizmekMeasurerCpmGeoproductAllowed?: boolean;
    isSizmekMeasurerCpmVideoAllowed?: boolean;
    isSizmekMeasurerCpmYndxFrontpageAllowed?: boolean;

    isWeboramaMeasurerCpmBannerAllowed?: boolean;
    isWeboramaMeasurerCpmAudioAllowed?: boolean;
    isWeboramaMeasurerCpmDealsAllowed?: boolean;
    isWeboramaMeasurerCpmGeoproductAllowed?: boolean;
    isWeboramaMeasurerCpmVideoAllowed?: boolean;
    isWeboramaMeasurerCpmYndxFrontpageAllowed?: boolean;

    isTnsEnabled?: boolean;

    isTycoonOrganizationsEnabled?: boolean;
    isCampaignDefaultOrganizationsEnabled?: boolean;
    isZeroSpeedPageForGeoproductEnabled?: boolean;
}

export interface Regions {
    [key: string]: {
        [key: string]: Region[];
    };
}

export type FreelancerCardState = {
    freelancer?: Freelancer;
    customer?: FreelancerCustomer;
    operator?: FreelancerCardOperator;
    pageState: FreelancerPageStates;
    isWithdrawRequestPending: boolean;
    cooperationBlockState: FreelancerPageStates;
    acceptRequestByClientPopupIsOpen: boolean;
    error?: Error;
};

export interface FreelancerAcceptPopup {
    isAcceptRequestPending: boolean;
    originPhone: string;
    lastValidPhone: string;
    editPhone: StringInputField;
}

export interface RecommendationsState {
    error?: string;
    recommendationsData?: Array<SummaryRecommendation>;
    recommendationsReqId: string;
}

export interface RecommendationsGridStateClientInfo {
    workCurrency: CurrencyCode;
    enabledRecommendationTypes: Array<GdiRecommendationType>;
}

export interface RecommendationsGridState {
    gridData: GridData;
    summaryRecommendationData?: RecommendationsGridSummaryRecommendation;
    isHorizontalScrollVisible: boolean;
    isHeaderVisible: boolean;
    columnsSettings: ColumnsSettingsViewDict;
    clientInfo: RecommendationsGridStateClientInfo;
    recommendationsGridReqId: string;
}

export interface HelpState {
    opened: boolean;
    helpId?: HelpLink;
}

export interface FreelancerFeedbackFormState extends FreelancerFeedbackCommonData {
    mode?: FreelancerFeedbackFormModes;
    isFreelancerFeedbackFormPending: boolean;
    feedbackId?: string;
}

export type ClientFreelancerData = {
    login: string;
    fullName: string;
    phone?: string;
    avatarLink: string;
};

export enum FreelancerPanelActions {
    myFreelancer = 'myFreelancer',
    myCustomer = 'myCustomer',
    becomeFreelancer = 'becomeFreelancer'
}

export type ClientMobileAppsData = {
    canViewMobileApps: boolean;
    canEditMobileApps: boolean;
    canEditMobileAppDomain: boolean;
    canViewMobileAppDomain: boolean;
};

export interface DealsState {
    gridData: DealsData;
    sourceParams: DealsSourceParams;
    dealsCacheKeysDict: DealsCacheKeysDict;
    columnsSettings: ColumnsSettingsViewDict;
    inspectorVisible: boolean;
    inspectorData?: DealDetail;
    allCampaigns?: {
        [key: string]: DropdownChooserItem[];
    };
    allClients?: DropdownChooserItem[];
    isInspectorLoading: boolean;
    inspectedDealIndex?: number;
    inspectorErrors: ValidationResultItem[];
    requestParams?: DealsUpdateObject;
    isInspectorHasChanges: boolean;
    inspectorErrorMessage?: string;
}

export interface HeaderState {
    isInfoBlockLoading: boolean;
    infoBlockData: HeaderInfoBlockData;
    userAccountsInfo?: UserAccountsInfo;
    // Текущее ID пользователя
    clientId?: string;
    // uid агенства или саппорта
    chiefUserId?: string;
    allowedMenuItems?: GdMenuItem[];
    dealsTotalCount?: number;
    availableCampaignsTypes?: CampaignType[];
    canSeeDealsLinkEverywhere?: boolean;
    wallet?: WalletData;
    isAgency?: boolean;
    role?: string;
    // id агенства
    agencyId?: string;
    isB2bBalanceCartEnabled?: boolean;
}

export interface PredictorState {
    data: Record<GroupId, PredictorData>;
    columnsSettings?: ColumnsSettingsViewDict;
    errors?: ValidationResultItem[];
}

export interface VideoCreatorListState {
    templateList: TemplateListItem[];
    myVideoList: VideoCreatorApiResponse[];
    loadingStatus: Record<string, boolean>;
}

export interface ImageUploaderState {
    [id: string]: {
        upload: boolean;
        resetEnabled: boolean;
        sourceImageUrl: string;
        imageUrl?: string;
    };
}

export type RetargetingEditorsState = Record<GroupId, RetargetingEditorState>;

export type RateCorrectionEditorsState = Record<string, RateCorrectionEditorState>;

export type InterestsEditorsState = Record<GroupId, InterestsTargetingEditorState>;

export type PlatformsPreviewEditorsState = Record<GroupId, PlatformsPreviewEditorState>;

export type PhrasesSelectorWizardsState = { [key in PhrasesSelectorWizardId]: PhrasesSelectorWizardState };

export type PhrasesSelectorsState = {
    persistentData: PhrasesSelectorsPersistentState;
} & {
    [key in PhrasesSelectorWizardId]?: PhrasesSelectorState;
};

export type ImageEditorState = {
    imageGallery: EditedBannerImageGallery;
    image: EditedBannerImage;
    imageUploadingLink: string;
    isImageCanvasOpen: boolean;
    isCropOpen?: boolean;
    isNew?: boolean;
    canvasPageType?: CanvasPageType;
};

export type CryptaSocialDemoEditorsState = Record<GroupId, CryptaSocialDemoEditorState>;

export type CryptaGroupFamilyEditorsState = Record<GroupId, CryptaGroupFamilyEditorState>;

export type CryptaAudioGenresEditorsState = Record<GroupId, CryptaAudioGenresEditorState>;

export type CryptaBehavioralEditorsState = Record<GroupId, CryptaBehavioralEditorState>;

export type AudienceTargetingsEditorsState = Record<GroupId, AudienceTargetingsEditorState>;

export type PITagsEditorsState = Record<GroupId, PITagsEditorState>;

export type ImageEditorsState = Record<ImageEditorId, ImageEditorState>;

export type TargetTagsEditorsState = Record<string, TargetTagsEditorState>;

export interface CanvasEditorState {
    sharedData: SharedData;
    html5: Html5State;
    itemNameEditors: ItemNameEditorsState;
    canvas: CanvasState;
}

export interface State {
    // commons
    commonData: CommonState;
    router: RoutesLocation;
    header: HeaderState;
    regions: RegionsState;
    devInfo: DevInfo;
    help: HelpState;

    // pages
    userSettings: UserSettingsState;
    welcome: WelcomeState;
    grid: GridState;
    log: LogState;
    freelancerCustomers: FreelancerCustomersState;
    reportClient: ReportsClientState;
    reportDomain: ReportsDomainState;
    mobileAppsList: MobileAppsListState;
    editCampaigns: EditCampaignsState;
    editBanners: EditBannersState;
    editInternalBanners: EditInternalBannersState;
    editGroups: EditGroupsState;
    recommendations: RecommendationsState;
    recommendationsGrid: RecommendationsGridState;
    mobileAppsCreate: MobileAppsState;
    deals: DealsState;
    freelancersList: FreelancersList;
    pricePackages: PricePackagesState;
    editPricePackages: PricePackagesEditState;
    videoCreatorList: VideoCreatorListState;
    videoCreatorEdit: VideoCreatorEditState;

    // editors and modals
    bannersEditMassActions: BannersEditMassActionsState;
    bannersPreviewData: BannersPreviewDataDict;
    phrasesSelectorWizard: PhrasesSelectorWizardsState;
    phrasesSelectors: PhrasesSelectorsState;
    freelancerCard: FreelancerCardState;
    freelancerCardEdit: FreelancerCardEditState;
    freelancerFeedbackForm: FreelancerFeedbackFormState;
    freelancerAcceptPopup: FreelancerAcceptPopup;
    rateCorrectionsEditor: RateCorrectionEditorsState;
    interestsTargetingEditor: InterestsEditorsState;
    cryptaSocialDemoEditor: CryptaSocialDemoEditorsState;
    cryptaGroupFamilyEditor: CryptaGroupFamilyEditorsState;
    cryptaAudioGenresEditor: CryptaAudioGenresEditorsState;
    cryptaBehavioralEditor: CryptaBehavioralEditorsState;
    platformsPreviewEditor: PlatformsPreviewEditorsState;
    audienceTargetingsEditor: AudienceTargetingsEditorsState;
    retargetingEditor: RetargetingEditorsState;
    retargetingConditionEditor: RetargetingConditionEditorState;
    outdoorMapEditor: OutdoorMapEditorState;
    indoorMapEditor: IndoorMapEditorState;
    video: VideoState;
    turbolandings: TurbolandingsState;
    regionsEditor: Record<GroupId, RegionsEditorState>;
    regionsTransformEditor: RegionsTransformEditorsState;
    regionsSearchEditor: RegionsSearchEditorsState;
    minusPhraseLibrary: MinusPhraseLibraryState;
    columnsSettingsEditor: ColumnsSettingsEditorState;
    goalsData: GoalsDataState;
    commonPriceEditor: CommonPriceEditorState;
    feedFilters: FeedFiltersState;
    imageEditor: ImageEditorsState;
    siteLinksEditor: BannersSiteLinksEditorState;
    bannersPriceEditor: EditorBannerPriceState;
    chatListEditor: ChatListEditorState;
    addChatListEditor: AddChatListEditorState;
    calloutsEditor: CalloutsEditorState;
    groupsEditMassActions: GroupsEditMassActionsState;
    minusPhraseLibraryEditor: MinusPhraseLibraryEditorState;
    metrikaCounterEditor: MetrikaCounterEditorState;
    relevantPhrasesEditor: CampaignsRelevantPhrasesEditorState;
    datesIntervalEditor: DatesIntervalEditorsState;
    editPageItemNameEditor: EditPageItemNameEditorsState;
    bannerCreativePreviewPopup: BannerCreativePreviewPopupState;
    recommendationsModal: RecommendationsModalState;
    pricePackagesClientsModal: PricePackagesClientsModalState;
    itemsListTextareaEditor: ItemsListTextareaEditorsState;
    organizationsEditor: OrganizationsEditorsState;
    organizationsData: OrganizationsDataState;
    metrikaKeyGoalsEditor: MetrikaKeyGoalsEditorState;
    notificationEditor: NotificationEditorsState;
    visitingCardEditor: VisitingCardEditorsState;
    experimentsEditor: ExperimentsEditorState;
    importExportWizard: ImportExportWizardState;
    importWizard: ImportWizardState;
    internalProductPlaces: InternalProductPlacesState;
    products: ProductsState;
    importWizardInfo: ImportWizardInfoState;
    marketersList: MarketersState;
    marketerCard: MarketerState;
    predictor: PredictorState;
    creative: CreativeState;
    campaignServiceEditor: CampaignServiceEditorState;
    campaignPlaceEditor: CampaignPlaceEditorState;
    strategyEditor: StrategyEditorState;
    timeTargetingEditor: TimeTargetingEditorsState;
    tagCloudTargetingEditor: TagCloudTargetingsState;
    imageSmartCenterEditor: ImageSmartCenterEditorState;
    trackingParametersState: TrackingParametersEditorsState;
    predictorEditor: PredictorData;
    retargetingAudienceEditor: RetargetingAudienceEditorState;
    keywordsEditor: KeywordsEditorsState;
    piTagsEditor: PITagsEditorsState;
    canvasEditor: CanvasEditorState;
    showsFrequencyEditor: ShowsFrequencyEditorState;
    pricePackagesEditor: PricePackageEditorState;
    targetTagsEditor: TargetTagsEditorsState;
    messages: MessagesState;
    imageUploaderEditor: ImageUploaderState;
}
